<div [formGroup]="editForm" class="k-form" *ngIf="loaded">
    <button kendoButton [primary]="true" (click)="addServiceType()" type="button" class="mb-2" *ngIf="!isDeleted">
        {{'ADD-RISK' | translate}}<i class="far fa-plus"></i>
    </button>
    <div formGroupName="serviceTypes" class="container-service-types">
        <table class="table mb-0">
            <thead>
                <tr>
                    <th>
                        <label class="control-label k-text-uppercase dark font-weight-normal">{{
                            'COMMUNITY-SERVICE-TYPE' | translate }}
                            *
                        </label>
                    </th>
                    <th>
                        <label class="control-label k-text-uppercase dark font-weight-normal text-center">{{
                            'RISK-SCORE' | translate }}
                            *
                        </label>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr style="position:relative;top:10px" *ngIf=" editForm.controls.serviceTypes.controls.length === 0">
                    {{'NO-RULES-SUMMARY' | translate}}
                </tr>
                <tr
                    *ngFor="let serviceType of editForm.controls.serviceTypes.controls; let i=index; trackBy:serviceTypesTrackBy;">
                    <td style="width:55%" [formGroupName]="i">
                        <kendo-combobox id="serviceType" formControlName="serviceType" [data]="serviceTypesLookup"
                            [textField]="'displayName'" [valueField]="'id'" class="w-100" tabindex="1">
                            <ng-template kendoComboBoxItemTemplate let-dataItem>
                                <i class="fas {{dataItem.icon}}" style="color:gray;"></i>&nbsp;{{ dataItem.displayName
                                }}
                            </ng-template>
                        </kendo-combobox>
                        <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.serviceTypes.controls[i].controls.serviceType.hasError('required') && 
                            editForm.controls.serviceTypes.controls[i].controls.serviceType.touched">
                            {{ 'COMMUNITY-SERVICE-TYPE-REQUIRED' | translate }}
                        </div>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="editForm.controls.serviceTypes.controls[i].controls.importError.value">
                            {{ 'ASSESSMENT-DATA-PARTIALLY-LOADED-HINT' | translate }}
                        </div>
                        <!--Add a mt-5 if no score to not overlap the Score is required message-->
                        <div [ngClass]="{'mt-5': editForm.controls.serviceTypes.controls[i].controls.score.hasError('required') && 
                        editForm.controls.serviceTypes.controls[i].controls.score.touched}" class="mt-2">
                            <app-formly-designer-rule-edit [ruleIndex]="i" [fields]="fields" [isDeleted]="isDeleted"
                                [expandWidth]="'188%'"
                                [showRules]="editForm.controls.serviceTypes.controls[i].controls.showRules.value"
                                [query]="editForm.controls.serviceTypes.controls[i].controls.query.value"
                                (showRulesChanged)="showRulesChanged($event)">
                            </app-formly-designer-rule-edit>
                        </div>
                    </td>
                    <td style="width:40%" [formGroupName]="i">
                        <kendo-numerictextbox [format]="'n0'" formControlName="score" class="w-50" [min]="0" [max]="10">
                        </kendo-numerictextbox>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="editForm.controls.serviceTypes.controls[i].controls.score.hasError('required') && editForm.controls.serviceTypes.controls[i].controls.score.touched">
                            {{ 'RISK-SCORE-REQUIRED' | translate }}
                        </div>
                    </td>
                    <td class="ng-untouched" *ngIf="!isDeleted">
                        <a title="{{ 'DELETE' | translate }}" (click)="removeServiceType(i)">
                            <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>